import { useState } from "react";
import { classNames } from "../utils";

function EyeIcon({ className }: { className?: string }) {
  return (
    <svg className={className} viewBox="0 0 20 20" fill="currentColor" aria-hidden>
      <path d="M10 3.5c-3.14 0-5.86 1.86-7.5 4.5 1.64 2.64 4.36 4.5 7.5 4.5s5.86-1.86 7.5-4.5c-1.64-2.64-4.36-4.5-7.5-4.5zm0 7.5a3 3 0 1 1 0-6 3 3 0 0 1 0 6z" />
    </svg>
  );
}

function EyeOffIcon({ className }: { className?: string }) {
  return (
    <svg className={className} viewBox="0 0 20 20" fill="currentColor" aria-hidden>
      <path d="M3.28 2.22a.75.75 0 0 0-1.06 1.06l1.1 1.1C2.7 5.03 1.64 6.46 1 8c1.64 2.64 4.36 4.5 7.5 4.5.9 0 1.76-.15 2.55-.42l1.17 1.17a.75.75 0 1 0 1.06-1.06L3.28 2.22zM8.1 7.04l1.86 1.86A1.5 1.5 0 0 0 8.1 7.04zm4.4 4.4-1.1-1.1a3 3 0 0 1-3.6-3.6l-1.1-1.1C5.14 6.36 3.5 8.14 3.5 10c1.64 2.64 4.36 4.5 7.5 4.5.76 0 1.49-.12 2.17-.34l-1.17-1.17a3 3 0 0 1-1.4.45zM10 3.5c.76 0 1.49.12 2.17.34l1.28 1.28a.75.75 0 1 0 1.06-1.06L13.33 2.78C12.3 2.43 11.17 2.25 10 2.25 6.86 2.25 4.14 4.11 2.5 6.75c.47.76 1.05 1.45 1.72 2.05l1.2-1.2A7.87 7.87 0 0 0 10 3.5zm5.3 3.45-1.2 1.2c.67.6 1.25 1.29 1.72 2.05 1.64-2.64 4.36-4.5 7.5-4.5.76 0 1.49.12 2.17.34l-1.28-1.28a.75.75 0 0 0-1.06 1.06z" />
    </svg>
  );
}

export function MaskedRevenue({
  amount,
  className,
  size = "sm",
}: {
  amount: number;
  className?: string;
  size?: "sm" | "lg";
}) {
  const [revealed, setRevealed] = useState(false);
  const formatted = `¥${amount.toLocaleString()}`;

  return (
    <span
      className={classNames(
        "group inline-flex max-w-full items-center gap-1 tabular-nums",
        size === "lg" ? "text-2xl font-semibold" : "text-xs font-medium",
        className,
      )}
    >
      <span className="truncate">{revealed ? formatted : "¥****"}</span>
      <button
        type="button"
        className={classNames(
          "shrink-0 rounded p-0.5 text-ink-400 transition-opacity hover:bg-ink-100 hover:text-ink-600",
          revealed ? "opacity-100" : "opacity-0 group-hover:opacity-100",
          size === "lg" ? "h-6 w-6" : "h-4 w-4",
        )}
        onClick={(e) => {
          e.stopPropagation();
          setRevealed((v) => !v);
        }}
        title={revealed ? "隐藏营收" : "显示营收"}
        aria-label={revealed ? "隐藏营收" : "显示营收"}
      >
        {revealed ? (
          <EyeOffIcon className="h-full w-full" />
        ) : (
          <EyeIcon className="h-full w-full" />
        )}
      </button>
    </span>
  );
}
